import { Panel } from "@mixitone/components/Controls";
import { ApplicationView } from "@mixitone/mvc";
import { ClubDetailsPageController } from "controllers/ClubDetailsPageController";
import { useMemo } from "react";

export const SessionTimesPanel = ApplicationView(() => {
  const controller = ClubDetailsPageController.use();
  const { sessions } = controller.state;
  const locale = useMemo(
    () => (typeof globalThis !== "undefined" && globalThis.navigator?.language) || "en-NZ",
    [],
  );

  if (sessions.length === 0) {
    return null;
  }

  return (
    <Panel title="Session times" titleClassName="font-semibold">
      {sessions.map((session, idx) => (
        <div key={idx}>{session.formatTitle(locale)}</div>
      ))}
    </Panel>
  );
});
